import {
  ErrorFallbackpage,
  ErrorScreenDesktop,
  MICRO_FRONTENDS_CONFIG,
  MicroFrontend,
  MicroFrontendConfigType,
} from '@amzn/rangoli-seller-desktop-utils/src/index';
import { observer } from 'mobx-react';
import React, { FC } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';

import App from '../App';
import MarketingPage from '../pages/marketingPage/marketingPage';
import { UserAuthStore } from '../store/UserAuthStore';
import {RangoliRouteProps, RangoliStaticRouteProps} from '../types/RangoliRouteProps';
import AcceptInvitePage from '@amzn/rangoli-seller-desktop-user-management-module/src/pages/AcceptInvitePage';

interface RoutingProps {
  store: UserAuthStore;
}

const getRouteMaps = (store: UserAuthStore): RangoliRouteProps[] => {
  const routes: RangoliRouteProps[] = [
    // fallback route
    {
      path: '/error',
      element: <ErrorFallbackpage />,
    },
    {
      path: '*',
      element: <ErrorScreenDesktop />,
    },
  ];
  return routes;
};

const STATIC_ROUTES: RangoliStaticRouteProps[] = [
  {
    path: '/',
    element: <MarketingPage />,
    isMatch: (pathname: string) => pathname === '/'
  },
  {
    path: '/accept-invite',
    element: <AcceptInvitePage />,
    isMatch: (pathname: string) => pathname === '/accept-invite'
  }
];

export const Routing: FC<RoutingProps> = observer(({ store }: RoutingProps) => {
  const location = useLocation();
  const routes = getRouteMaps(store);
  const microFrontendRoutes: MicroFrontendConfigType[] = Object.values(MICRO_FRONTENDS_CONFIG);

  const staticRoute = STATIC_ROUTES.find((route) =>
      route.isMatch(location.pathname)
  );

  return (
    <Routes>
      {staticRoute ? (
        <Route path={staticRoute.path} element={staticRoute.element} />
      ) : (
        <Route path="/" element={<App store={store} />}>
          {routes.map((route: RangoliRouteProps, i: number): React.ReactNode => {
            return <Route {...route} key={i} />;
          })}
          {microFrontendRoutes?.map(
            (microFrontendConfig: MicroFrontendConfigType): React.ReactNode => {
              return (
                <Route
                  path={`/${microFrontendConfig.path}/*`}
                  key={microFrontendConfig.key}
                  element={
                    <MicroFrontend
                      remoteEntryPointUrl={microFrontendConfig.remoteUrl}
                      scope={microFrontendConfig.scope}
                      module={microFrontendConfig.module}
                    />
                  }
                />
              );
            }
          )}
        </Route>
      )}
    </Routes>
  );
});
